import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import React from 'react';
export const ModalDialog = /*#__PURE__*/ React.forwardRef((props, ref)=>{
    const { className, contentClassName, centered, bsSize, children, scrollable, fullscreen = false, ...rest } = props;
    return /*#__PURE__*/ _jsx("div", {
        ...rest,
        ref: ref,
        className: classNames('modal-dialog', className, bsSize && `modal-${bsSize}`, centered && 'modal-dialog-centered', scrollable && 'modal-dialog-scrollable', fullscreen === true && 'modal-fullscreen', fullscreen && fullscreen !== true && `modal-fullscreen-${fullscreen}-down`),
        children: /*#__PURE__*/ _jsx("div", {
            className: classNames('modal-content', contentClassName),
            children: children
        })
    });
});
ModalDialog.displayName = 'ModalDialog';
